// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/landscape.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from enum mono.datagateway.v1.LandscapeCriterionKind
 */ export var LandscapeCriterionKind = /*#__PURE__*/ function(LandscapeCriterionKind) {
    /**
   * @generated from enum value: LANDSCAPE_CRITERION_KIND_UNSPECIFIED = 0;
   */ LandscapeCriterionKind[LandscapeCriterionKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: LANDSCAPE_CRITERION_KIND_AGENCY = 1;
   */ LandscapeCriterionKind[LandscapeCriterionKind["AGENCY"] = 1] = "AGENCY";
    /**
   * @generated from enum value: LANDSCAPE_CRITERION_KIND_NAICS = 2;
   */ LandscapeCriterionKind[LandscapeCriterionKind["NAICS"] = 2] = "NAICS";
    /**
   * @generated from enum value: LANDSCAPE_CRITERION_KIND_PSC = 3;
   */ LandscapeCriterionKind[LandscapeCriterionKind["PSC"] = 3] = "PSC";
    /**
   * @generated from enum value: LANDSCAPE_CRITERION_KIND_CAPABILITY = 4;
   */ LandscapeCriterionKind[LandscapeCriterionKind["CAPABILITY"] = 4] = "CAPABILITY";
    return LandscapeCriterionKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(LandscapeCriterionKind)
proto3.util.setEnumType(LandscapeCriterionKind, "mono.datagateway.v1.LandscapeCriterionKind", [
    {
        no: 0,
        name: "LANDSCAPE_CRITERION_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "LANDSCAPE_CRITERION_KIND_AGENCY"
    },
    {
        no: 2,
        name: "LANDSCAPE_CRITERION_KIND_NAICS"
    },
    {
        no: 3,
        name: "LANDSCAPE_CRITERION_KIND_PSC"
    },
    {
        no: 4,
        name: "LANDSCAPE_CRITERION_KIND_CAPABILITY"
    }
]);
/**
 * An input rule: opportunities carrying an attribute of the same kind and
 * (case-insensitive, trimmed) value match.
 *
 * @generated from message mono.datagateway.v1.LandscapeCriterionInput
 */ export class LandscapeCriterionInput extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeCriterionInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeCriterionInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeCriterionInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeCriterionInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LandscapeCriterionKind kind = 1;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string value = 2;
   */ _define_property(this, "value", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeCriterionInput, "runtime", proto3);
_define_property(LandscapeCriterionInput, "typeName", "mono.datagateway.v1.LandscapeCriterionInput");
_define_property(LandscapeCriterionInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(LandscapeCriterionKind)
        },
        {
            no: 2,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LandscapeCriterion
 */ export class LandscapeCriterion extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeCriterion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeCriterion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeCriterion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeCriterion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.LandscapeCriterionKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string value = 3;
   */ _define_property(this, "value", ""), /**
   * Hash of the rule definition; a changed rule is a new criterion with a new
   * fingerprint, created after any earlier manual removal.
   *
   * @generated from field: string fingerprint = 4;
   */ _define_property(this, "fingerprint", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeCriterion, "runtime", proto3);
_define_property(LandscapeCriterion, "typeName", "mono.datagateway.v1.LandscapeCriterion");
_define_property(LandscapeCriterion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(LandscapeCriterionKind)
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Landscape
 */ export class Landscape extends Message {
    static fromBinary(bytes, options) {
        return new Landscape().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Landscape().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Landscape().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Landscape, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string scope = 4;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: repeated string organization_ids = 5;
   */ _define_property(this, "organizationIds", []), /**
   * @generated from field: repeated string capabilities = 6;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: string context = 7;
   */ _define_property(this, "context", ""), /**
   * @generated from field: bool observed_only = 8;
   */ _define_property(this, "observedOnly", false), /**
   * @generated from field: string created_by = 9;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.LandscapeCriterion criteria = 12;
   */ _define_property(this, "criteria", []), /**
   * @generated from field: int32 active_member_count = 13;
   */ _define_property(this, "activeMemberCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Landscape, "runtime", proto3);
_define_property(Landscape, "typeName", "mono.datagateway.v1.Landscape");
_define_property(Landscape, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "organization_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "capabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "observed_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "criteria",
            kind: "message",
            T: LandscapeCriterion,
            repeated: true
        },
        {
            no: 13,
            name: "active_member_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateLandscapeRequest
 */ export class CreateLandscapeRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateLandscapeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLandscapeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLandscapeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLandscapeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string created_by = 2;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string scope = 4;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: repeated string organization_ids = 5;
   */ _define_property(this, "organizationIds", []), /**
   * @generated from field: repeated string capabilities = 6;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: string context = 7;
   */ _define_property(this, "context", ""), /**
   * @generated from field: bool observed_only = 8;
   */ _define_property(this, "observedOnly", false), /**
   * @generated from field: repeated mono.datagateway.v1.LandscapeCriterionInput criteria = 9;
   */ _define_property(this, "criteria", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLandscapeRequest, "runtime", proto3);
_define_property(CreateLandscapeRequest, "typeName", "mono.datagateway.v1.CreateLandscapeRequest");
_define_property(CreateLandscapeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "organization_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "capabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "observed_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "criteria",
            kind: "message",
            T: LandscapeCriterionInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateLandscapeResponse
 */ export class CreateLandscapeResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateLandscapeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLandscapeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLandscapeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLandscapeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Landscape landscape = 1;
   */ _define_property(this, "landscape", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLandscapeResponse, "runtime", proto3);
_define_property(CreateLandscapeResponse, "typeName", "mono.datagateway.v1.CreateLandscapeResponse");
_define_property(CreateLandscapeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape",
            kind: "message",
            T: Landscape
        }
    ]));
/**
 * Full replace of the editable fields. Criteria are diffed by (kind, value):
 * unchanged rules keep their id and fingerprint, new ones are added, absent
 * ones are retired.
 *
 * @generated from message mono.datagateway.v1.UpdateLandscapeRequest
 */ export class UpdateLandscapeRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateLandscapeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateLandscapeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateLandscapeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateLandscapeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string scope = 4;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: repeated string organization_ids = 5;
   */ _define_property(this, "organizationIds", []), /**
   * @generated from field: repeated string capabilities = 6;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: string context = 7;
   */ _define_property(this, "context", ""), /**
   * @generated from field: bool observed_only = 8;
   */ _define_property(this, "observedOnly", false), /**
   * @generated from field: repeated mono.datagateway.v1.LandscapeCriterionInput criteria = 9;
   */ _define_property(this, "criteria", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateLandscapeRequest, "runtime", proto3);
_define_property(UpdateLandscapeRequest, "typeName", "mono.datagateway.v1.UpdateLandscapeRequest");
_define_property(UpdateLandscapeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "organization_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "capabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "observed_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "criteria",
            kind: "message",
            T: LandscapeCriterionInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateLandscapeResponse
 */ export class UpdateLandscapeResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateLandscapeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateLandscapeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateLandscapeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateLandscapeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Landscape landscape = 1;
   */ _define_property(this, "landscape", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateLandscapeResponse, "runtime", proto3);
_define_property(UpdateLandscapeResponse, "typeName", "mono.datagateway.v1.UpdateLandscapeResponse");
_define_property(UpdateLandscapeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape",
            kind: "message",
            T: Landscape
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLandscapeRequest
 */ export class GetLandscapeRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeRequest, "runtime", proto3);
_define_property(GetLandscapeRequest, "typeName", "mono.datagateway.v1.GetLandscapeRequest");
_define_property(GetLandscapeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLandscapeResponse
 */ export class GetLandscapeResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Landscape landscape = 1;
   */ _define_property(this, "landscape", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeResponse, "runtime", proto3);
_define_property(GetLandscapeResponse, "typeName", "mono.datagateway.v1.GetLandscapeResponse");
_define_property(GetLandscapeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape",
            kind: "message",
            T: Landscape
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLandscapesRequest
 */ export class ListLandscapesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapesRequest, "runtime", proto3);
_define_property(ListLandscapesRequest, "typeName", "mono.datagateway.v1.ListLandscapesRequest");
_define_property(ListLandscapesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLandscapesResponse
 */ export class ListLandscapesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Landscape landscapes = 1;
   */ _define_property(this, "landscapes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapesResponse, "runtime", proto3);
_define_property(ListLandscapesResponse, "typeName", "mono.datagateway.v1.ListLandscapesResponse");
_define_property(ListLandscapesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscapes",
            kind: "message",
            T: Landscape,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LandscapeMember
 */ export class LandscapeMember extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeMember().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeMember().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeMember().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeMember, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string opportunity_title = 4;
   */ _define_property(this, "opportunityTitle", ""), /**
   * "rule" | "manual"
   *
   * @generated from field: string basis = 5;
   */ _define_property(this, "basis", ""), /**
   * Rule that added it (basis "rule"); empty for manual.
   *
   * @generated from field: string rule_id = 6;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: mono.datagateway.v1.LandscapeCriterionKind rule_kind = 7;
   */ _define_property(this, "ruleKind", 0), /**
   * @generated from field: string rule_value = 8;
   */ _define_property(this, "ruleValue", ""), /**
   * "active" | "removed"
   *
   * @generated from field: string state = 9;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string removed_by = 10;
   */ _define_property(this, "removedBy", ""), /**
   * @generated from field: string removal_reason = 11;
   */ _define_property(this, "removalReason", ""), /**
   * @generated from field: google.protobuf.Timestamp removed_at = 12;
   */ _define_property(this, "removedAt", void 0), /**
   * Non-empty when a removed member still matches an unchanged rule that was
   * not allowed to re-add it, e.g. "suppressed by manual correction".
   *
   * @generated from field: string suppression_reason = 13;
   */ _define_property(this, "suppressionReason", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeMember, "runtime", proto3);
_define_property(LandscapeMember, "typeName", "mono.datagateway.v1.LandscapeMember");
_define_property(LandscapeMember, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "opportunity_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rule_kind",
            kind: "enum",
            T: proto3.getEnumType(LandscapeCriterionKind)
        },
        {
            no: 8,
            name: "rule_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "removed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "removal_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "removed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "suppression_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLandscapeMembersRequest
 */ export class ListLandscapeMembersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeMembersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeMembersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeMembersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeMembersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * Default lists active members only.
   *
   * @generated from field: bool include_removed = 3;
   */ _define_property(this, "includeRemoved", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeMembersRequest, "runtime", proto3);
_define_property(ListLandscapeMembersRequest, "typeName", "mono.datagateway.v1.ListLandscapeMembersRequest");
_define_property(ListLandscapeMembersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLandscapeMembersResponse
 */ export class ListLandscapeMembersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeMembersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeMembersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeMembersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeMembersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LandscapeMember members = 1;
   */ _define_property(this, "members", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeMembersResponse, "runtime", proto3);
_define_property(ListLandscapeMembersResponse, "typeName", "mono.datagateway.v1.ListLandscapeMembersResponse");
_define_property(ListLandscapeMembersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "members",
            kind: "message",
            T: LandscapeMember,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddLandscapeMemberRequest
 */ export class AddLandscapeMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddLandscapeMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddLandscapeMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddLandscapeMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddLandscapeMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string actor = 4;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddLandscapeMemberRequest, "runtime", proto3);
_define_property(AddLandscapeMemberRequest, "typeName", "mono.datagateway.v1.AddLandscapeMemberRequest");
_define_property(AddLandscapeMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddLandscapeMemberResponse
 */ export class AddLandscapeMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddLandscapeMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddLandscapeMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddLandscapeMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddLandscapeMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LandscapeMember member = 1;
   */ _define_property(this, "member", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddLandscapeMemberResponse, "runtime", proto3);
_define_property(AddLandscapeMemberResponse, "typeName", "mono.datagateway.v1.AddLandscapeMemberResponse");
_define_property(AddLandscapeMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "member",
            kind: "message",
            T: LandscapeMember
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemoveLandscapeMemberRequest
 */ export class RemoveLandscapeMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveLandscapeMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveLandscapeMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveLandscapeMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveLandscapeMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string actor = 4;
   */ _define_property(this, "actor", ""), /**
   * Required.
   *
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveLandscapeMemberRequest, "runtime", proto3);
_define_property(RemoveLandscapeMemberRequest, "typeName", "mono.datagateway.v1.RemoveLandscapeMemberRequest");
_define_property(RemoveLandscapeMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemoveLandscapeMemberResponse
 */ export class RemoveLandscapeMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveLandscapeMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveLandscapeMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveLandscapeMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveLandscapeMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LandscapeMember member = 1;
   */ _define_property(this, "member", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveLandscapeMemberResponse, "runtime", proto3);
_define_property(RemoveLandscapeMemberResponse, "typeName", "mono.datagateway.v1.RemoveLandscapeMemberResponse");
_define_property(RemoveLandscapeMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "member",
            kind: "message",
            T: LandscapeMember
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RunLandscapeRulesRequest
 */ export class RunLandscapeRulesRequest extends Message {
    static fromBinary(bytes, options) {
        return new RunLandscapeRulesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunLandscapeRulesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunLandscapeRulesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RunLandscapeRulesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RunLandscapeRulesRequest, "runtime", proto3);
_define_property(RunLandscapeRulesRequest, "typeName", "mono.datagateway.v1.RunLandscapeRulesRequest");
_define_property(RunLandscapeRulesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RunLandscapeRulesResponse
 */ export class RunLandscapeRulesResponse extends Message {
    static fromBinary(bytes, options) {
        return new RunLandscapeRulesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunLandscapeRulesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunLandscapeRulesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RunLandscapeRulesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 added = 1;
   */ _define_property(this, "added", 0), /**
   * Re-added because the matching rule changed after the manual removal.
   *
   * @generated from field: int32 resuggested = 2;
   */ _define_property(this, "resuggested", 0), /**
   * Matched an unchanged rule but a later manual removal wins.
   *
   * @generated from field: int32 suppressed = 3;
   */ _define_property(this, "suppressed", 0), /**
   * @generated from field: int32 unchanged = 4;
   */ _define_property(this, "unchanged", 0), /**
   * @generated from field: repeated string suppressed_opportunity_ids = 5;
   */ _define_property(this, "suppressedOpportunityIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RunLandscapeRulesResponse, "runtime", proto3);
_define_property(RunLandscapeRulesResponse, "typeName", "mono.datagateway.v1.RunLandscapeRulesResponse");
_define_property(RunLandscapeRulesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "added",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "resuggested",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "suppressed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "unchanged",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "suppressed_opportunity_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LandscapeMemberEvent
 */ export class LandscapeMemberEvent extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeMemberEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeMemberEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeMemberEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeMemberEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", ""), /**
   * "rule_add" | "rule_resuggest" | "rule_suppressed" | "manual_add" | "manual_remove"
   *
   * @generated from field: string action = 4;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string basis = 5;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string rule_id = 6;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: string rule_fingerprint = 7;
   */ _define_property(this, "ruleFingerprint", ""), /**
   * @generated from field: string actor = 8;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string reason = 9;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeMemberEvent, "runtime", proto3);
_define_property(LandscapeMemberEvent, "typeName", "mono.datagateway.v1.LandscapeMemberEvent");
_define_property(LandscapeMemberEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rule_fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLandscapeMemberHistoryRequest
 */ export class ListLandscapeMemberHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeMemberHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeMemberHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeMemberHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeMemberHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * Optional: narrow to one opportunity.
   *
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeMemberHistoryRequest, "runtime", proto3);
_define_property(ListLandscapeMemberHistoryRequest, "typeName", "mono.datagateway.v1.ListLandscapeMemberHistoryRequest");
_define_property(ListLandscapeMemberHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLandscapeMemberHistoryResponse
 */ export class ListLandscapeMemberHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeMemberHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeMemberHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeMemberHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeMemberHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LandscapeMemberEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeMemberHistoryResponse, "runtime", proto3);
_define_property(ListLandscapeMemberHistoryResponse, "typeName", "mono.datagateway.v1.ListLandscapeMemberHistoryResponse");
_define_property(ListLandscapeMemberHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: LandscapeMemberEvent,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OpportunityAttributeInput
 */ export class OpportunityAttributeInput extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityAttributeInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityAttributeInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityAttributeInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityAttributeInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: mono.datagateway.v1.LandscapeCriterionKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string value = 3;
   */ _define_property(this, "value", ""), /**
   * Provenance; only "notice" is accepted, and only notice-sourced rows are replaced.
   *
   * @generated from field: string source = 4;
   */ _define_property(this, "source", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityAttributeInput, "runtime", proto3);
_define_property(OpportunityAttributeInput, "typeName", "mono.datagateway.v1.OpportunityAttributeInput");
_define_property(OpportunityAttributeInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(LandscapeCriterionKind)
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Every opportunity_id in items is replaced: its notice-sourced attributes are
 * dropped and re-created from items. An id with no items therefore clears its
 * derived attributes. Ids not in tenant_id are ignored.
 *
 * @generated from message mono.datagateway.v1.SyncOpportunityAttributesRequest
 */ export class SyncOpportunityAttributesRequest extends Message {
    static fromBinary(bytes, options) {
        return new SyncOpportunityAttributesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncOpportunityAttributesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncOpportunityAttributesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncOpportunityAttributesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Opportunities whose derived attributes are authoritative in this call,
   * even when they have no items.
   *
   * @generated from field: repeated string opportunity_ids = 2;
   */ _define_property(this, "opportunityIds", []), /**
   * @generated from field: repeated mono.datagateway.v1.OpportunityAttributeInput items = 3;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncOpportunityAttributesRequest, "runtime", proto3);
_define_property(SyncOpportunityAttributesRequest, "typeName", "mono.datagateway.v1.SyncOpportunityAttributesRequest");
_define_property(SyncOpportunityAttributesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "items",
            kind: "message",
            T: OpportunityAttributeInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SyncOpportunityAttributesResponse
 */ export class SyncOpportunityAttributesResponse extends Message {
    static fromBinary(bytes, options) {
        return new SyncOpportunityAttributesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncOpportunityAttributesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncOpportunityAttributesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncOpportunityAttributesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 opportunities_synced = 1;
   */ _define_property(this, "opportunitiesSynced", 0), /**
   * @generated from field: int32 opportunities_ignored = 2;
   */ _define_property(this, "opportunitiesIgnored", 0), /**
   * @generated from field: int32 attributes_written = 3;
   */ _define_property(this, "attributesWritten", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncOpportunityAttributesResponse, "runtime", proto3);
_define_property(SyncOpportunityAttributesResponse, "typeName", "mono.datagateway.v1.SyncOpportunityAttributesResponse");
_define_property(SyncOpportunityAttributesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities_synced",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "opportunities_ignored",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "attributes_written",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLandscapeStoryRequest
 */ export class GetLandscapeStoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeStoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeStoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeStoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeStoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: bool include_removed = 3;
   */ _define_property(this, "includeRemoved", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeStoryRequest, "runtime", proto3);
_define_property(GetLandscapeStoryRequest, "typeName", "mono.datagateway.v1.GetLandscapeStoryRequest");
_define_property(GetLandscapeStoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLandscapeStoryResponse
 */ export class GetLandscapeStoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeStoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeStoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeStoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeStoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LandscapeStoryThread threads = 1;
   */ _define_property(this, "threads", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeStoryResponse, "runtime", proto3);
_define_property(GetLandscapeStoryResponse, "typeName", "mono.datagateway.v1.GetLandscapeStoryResponse");
_define_property(GetLandscapeStoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "threads",
            kind: "message",
            T: LandscapeStoryThread,
            repeated: true
        }
    ]));
/**
 * A canonical Opportunity is one business thread, regardless of work count.
 *
 * @generated from message mono.datagateway.v1.LandscapeStoryThread
 */ export class LandscapeStoryThread extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeStoryThread().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeStoryThread().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeStoryThread().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeStoryThread, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string membership_state = 2;
   */ _define_property(this, "membershipState", ""), /**
   * @generated from field: repeated mono.datagateway.v1.LandscapeStoryRecord records = 3;
   */ _define_property(this, "records", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeStoryThread, "runtime", proto3);
_define_property(LandscapeStoryThread, "typeName", "mono.datagateway.v1.LandscapeStoryThread");
_define_property(LandscapeStoryThread, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "membership_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "records",
            kind: "message",
            T: LandscapeStoryRecord,
            repeated: true
        }
    ]));
/**
 * Reference metadata only: no raw notes, economics or Delivery finances.
 *
 * @generated from message mono.datagateway.v1.LandscapeStoryRecord
 */ export class LandscapeStoryRecord extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeStoryRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeStoryRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeStoryRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeStoryRecord, a, b);
    }
    constructor(data){
        super(), /**
   * opportunity | notice | award | capture_project | rfi_response | proposal | program
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * Owning source's current status, never a universal lifecycle state.
   *
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * Whether the owning row/reference is live; stopped/lost status is retained.
   *
   * @generated from field: bool current = 5;
   */ _define_property(this, "current", false), /**
   * @generated from field: repeated mono.datagateway.v1.LandscapeStoryEvent history = 6;
   */ _define_property(this, "history", []), /**
   * @generated from field: repeated mono.datagateway.v1.LandscapeStoryEntity entities = 9;
   */ _define_property(this, "entities", []), /**
   * Recognized active owning-source states; unknown states remain history-only.
   *
   * @generated from field: bool current_work = 10;
   */ _define_property(this, "currentWork", false), /**
   * Internal authorization targets; morgans does not expose these to browsers.
   *
   * @generated from field: string scope_object_type = 7;
   */ _define_property(this, "scopeObjectType", ""), /**
   * @generated from field: string scope_object_id = 8;
   */ _define_property(this, "scopeObjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeStoryRecord, "runtime", proto3);
_define_property(LandscapeStoryRecord, "typeName", "mono.datagateway.v1.LandscapeStoryRecord");
_define_property(LandscapeStoryRecord, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "current",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "history",
            kind: "message",
            T: LandscapeStoryEvent,
            repeated: true
        },
        {
            no: 9,
            name: "entities",
            kind: "message",
            T: LandscapeStoryEntity,
            repeated: true
        },
        {
            no: 10,
            name: "current_work",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "scope_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "scope_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LandscapeStoryEvent
 */ export class LandscapeStoryEvent extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeStoryEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeStoryEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeStoryEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeStoryEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * market_published | company_action | learned_associated
   *
   * @generated from field: string category = 2;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string action = 3;
   */ _define_property(this, "action", ""), /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 4;
   */ _define_property(this, "occurredAt", void 0), /**
   * @generated from field: string source_table = 5;
   */ _define_property(this, "sourceTable", ""), /**
   * @generated from field: string source_id = 6;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string date_field = 7;
   */ _define_property(this, "dateField", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeStoryEvent, "runtime", proto3);
_define_property(LandscapeStoryEvent, "typeName", "mono.datagateway.v1.LandscapeStoryEvent");
_define_property(LandscapeStoryEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "occurred_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "source_table",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "date_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Public/shared entity context from an authorized source record. An identifier
 * is present only when supplied by that source (e.g. an awardee UEI).
 *
 * @generated from message mono.datagateway.v1.LandscapeStoryEntity
 */ export class LandscapeStoryEntity extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeStoryEntity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeStoryEntity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeStoryEntity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeStoryEntity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string identifier = 2;
   */ _define_property(this, "identifier", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string source_id = 4;
   */ _define_property(this, "sourceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeStoryEntity, "runtime", proto3);
_define_property(LandscapeStoryEntity, "typeName", "mono.datagateway.v1.LandscapeStoryEntity");
_define_property(LandscapeStoryEntity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Personal state: tenant and actor are supplied by the authenticated facade.
 *
 * @generated from message mono.datagateway.v1.LandscapePatternState
 */ export class LandscapePatternState extends Message {
    static fromBinary(bytes, options) {
        return new LandscapePatternState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapePatternState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapePatternState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapePatternState, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string pattern_key = 1;
   */ _define_property(this, "patternKey", ""), /**
   * @generated from field: string dismissal_reason = 2;
   */ _define_property(this, "dismissalReason", ""), /**
   * @generated from field: string profile_id = 3;
   */ _define_property(this, "profileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapePatternState, "runtime", proto3);
_define_property(LandscapePatternState, "typeName", "mono.datagateway.v1.LandscapePatternState");
_define_property(LandscapePatternState, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pattern_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "dismissal_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLandscapePatternStateRequest
 */ export class GetLandscapePatternStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapePatternStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapePatternStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapePatternStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapePatternStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string pattern_key = 4;
   */ _define_property(this, "patternKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapePatternStateRequest, "runtime", proto3);
_define_property(GetLandscapePatternStateRequest, "typeName", "mono.datagateway.v1.GetLandscapePatternStateRequest");
_define_property(GetLandscapePatternStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pattern_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveLandscapePatternStateRequest
 */ export class SaveLandscapePatternStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveLandscapePatternStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveLandscapePatternStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveLandscapePatternStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveLandscapePatternStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: mono.datagateway.v1.LandscapePatternState state = 4;
   */ _define_property(this, "state", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveLandscapePatternStateRequest, "runtime", proto3);
_define_property(SaveLandscapePatternStateRequest, "typeName", "mono.datagateway.v1.SaveLandscapePatternStateRequest");
_define_property(SaveLandscapePatternStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "message",
            T: LandscapePatternState
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLandscapePatternStateResponse
 */ export class GetLandscapePatternStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapePatternStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapePatternStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapePatternStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapePatternStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LandscapePatternState state = 1;
   */ _define_property(this, "state", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapePatternStateResponse, "runtime", proto3);
_define_property(GetLandscapePatternStateResponse, "typeName", "mono.datagateway.v1.GetLandscapePatternStateResponse");
_define_property(GetLandscapePatternStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state",
            kind: "message",
            T: LandscapePatternState
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveLandscapePatternStateResponse
 */ export class SaveLandscapePatternStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveLandscapePatternStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveLandscapePatternStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveLandscapePatternStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveLandscapePatternStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LandscapePatternState state = 1;
   */ _define_property(this, "state", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveLandscapePatternStateResponse, "runtime", proto3);
_define_property(SaveLandscapePatternStateResponse, "typeName", "mono.datagateway.v1.SaveLandscapePatternStateResponse");
_define_property(SaveLandscapePatternStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state",
            kind: "message",
            T: LandscapePatternState
        }
    ]));
